var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { RadioGroup } from '../RadioGroup/index.js';
import { HelperText } from './HelperText.js';
import { Label } from './Label.js';
export const FormControlRadioGroup = props => {
    const { children, name, label, helperText, error, invalid, hidden, onChange } = props, rest = __rest(props, ["children", "name", "label", "helperText", "error", "invalid", "hidden", "onChange"]);
    return (React.createElement("div", { className: "space-y-1", hidden: hidden },
        label ? React.createElement(Label, { htmlFor: name }, label) : null,
        !invalid && helperText && (React.createElement(HelperText, { invalid: invalid }, helperText)),
        React.createElement(RadioGroup, Object.assign({}, rest, { onChange: onChange, name: name }), children),
        invalid && error && (React.createElement("div", { className: "pt-1" },
            React.createElement(HelperText, { invalid: invalid }, error)))));
};
//# sourceMappingURL=FormControlRadioGroup.js.map